"use client";

import { useEffect } from "react";

/**
 * Catches errors thrown in the root layout itself. It replaces the entire
 * document, so it must render its own <html>/<body> and cannot rely on the app
 * providers, theme, or globals.css — styles are inlined.
 */
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("[GlobalError]", error);
  }, [error]);

  return (
    <html lang="en">
      <body
        style={{
          margin: 0,
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontFamily:
            "system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
          background: "#fff",
          color: "#1a1a1a",
        }}
      >
        <div style={{ textAlign: "center", maxWidth: 480, padding: 24 }}>
          <h1 style={{ fontSize: 24, fontWeight: 700, marginBottom: 8 }}>
            Something went wrong
          </h1>
          <p style={{ fontSize: 16, color: "#555", marginBottom: 24 }}>
            A critical error occurred while loading the application.
          </p>
          {error?.digest && (
            <p
              style={{
                fontSize: 12,
                color: "#999",
                marginBottom: 24,
                fontFamily: "monospace",
              }}
            >
              Reference: {error.digest}
            </p>
          )}
          <button
            onClick={() => reset()}
            style={{
              padding: "8px 16px",
              borderRadius: 4,
              border: "none",
              background: "#1a1a1a",
              color: "#fff",
              cursor: "pointer",
              fontSize: 14,
            }}
          >
            Try again
          </button>
        </div>
      </body>
    </html>
  );
}
